export const getStatusColor = (status: string) => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'processing':
      return 'info';
    case 'cancelled':
      return 'secondary';
    default:
      return 'light';
  }
};
